module.exports = __webpack_public_path__ + "img/join-1.beb75648.png";